import 'reflect-metadata';
import {
  container,
  instancePerContainerCachingFactory,
  registry,
} from 'tsyringe';
import {
  kNameOfNotificationWindowService,
  INotificationWindowService,
} from 'app-core/src/interfaces/notification-window-service.interface';
import {
  kNameOfUserActionService,
  IUserActionService,
} from 'app-core/src/interfaces/user-action-service.interface';
import { LoggerService } from 'app-core/src/services/logger.service';
import { WindowsTunnelDataService } from '../shared/services/windows-tunnel-data.service';
import { NotificationController } from './notification.controller';
import './notification.scss';
import { Sentry } from '../shared/utils/sentry';
import {
  kDITokenWindowListener,
  kDITOWWrapper,
} from 'app-core/src/constants/injectionTokens';
import { IOWWrapper } from 'app-core/src/interfaces/ow-wrappers/ow-wrapper.interface';
import { OWWrapper } from '../shared/wrappers/ow-wrapper';
import { IOWWindowsListenerDelegateProvider } from 'app-core/src/interfaces/ow-wrappers/ow-window-listener-delegate-wrapper.interface';
import { OWGameListenerWrapper } from '../background/ow-odk-wrappers/ow-game-listener-wrapper';

// -----------------------------------------------------------------------------
@registry([
  {
    token: kNameOfNotificationWindowService,
    useFactory: instancePerContainerCachingFactory<INotificationWindowService>(
      (c) => {
        const tunnelDataService = c.resolve(WindowsTunnelDataService);
        return tunnelDataService.get(kNameOfNotificationWindowService);
      },
    ),
  },
  {
    token: kNameOfUserActionService,
    useFactory: instancePerContainerCachingFactory<IUserActionService>((c) => {
      const tunnelDataService = c.resolve(WindowsTunnelDataService);
      return tunnelDataService.get(kNameOfUserActionService);
    }),
  },
  // ---------------------------------------------------------------------------
  {
    token: kDITOWWrapper,
    useFactory: instancePerContainerCachingFactory<IOWWrapper>((c) => {
      return c.resolve(OWWrapper);
    }),
  },
  // ---------------------------------------------------------------------------
  {
    token: kDITokenWindowListener,
    useFactory:
      instancePerContainerCachingFactory<IOWWindowsListenerDelegateProvider>(
        (c) => {
          return c.resolve(
            OWGameListenerWrapper,
          ) as IOWWindowsListenerDelegateProvider;
        },
      ),
  },
])
class NotificationRegistry {}

// -----------------------------------------------------------------------------
const startup = () => {
  Sentry.initSentry();
  LoggerService.setup('Overwolf Notifications');
  const controller = container.resolve(NotificationController);
  controller.run();
};

startup();
